:host {
  display: flex;
  align-items: center;
  flex-direction: column;

  --_omk-animation-caption-font-family: var(--omk-animation-caption-font-family, var(--omk-font-headline-xsmall-font-family));
  --_omk-animation-caption-font-size: var(--omk-animation-caption-font-size, var(--omk-font-headline-xsmall-font-size));
  --_omk-animation-caption-font-weight: var(--omk-animation-caption-font-weight, var(--omk-font-headline-xsmall-font-weight));
  --_omk-animation-caption-line-height: var(--omk-animation-caption-line-height, var(--omk-font-headline-xsmall-line-height));
  --_omk-animation-caption-letter-spacing: var(--omk-animation-caption-letter-spacing, var(--omk-font-headline-xsmall-letter-spacing));
  --_omk-animation-caption-colour: var(--omk-animation-caption-colour, var(--omk-colour-text-primary-resting));

  --_omk-animation-canvas-height: var(--omk-animation-canvas-height, 100%);
  --_omk-animation-canvas-width: var(--omk-animation-canvas-width, 100%);
  --_omk-animation-canvas-max-width: var(--omk-animation-canvas-max-width, 100%);

  --_omk-animation-viewbox: var(--omk-animation-viewbox);
  --_omk-animation-preserve-aspect-ratio: var(--omk-animation-preserve-aspect-ratio, 'xMidYMid slice');
}

.caption {
  color: var(--_omk-animation-caption-colour);
  font-family: var(--_omk-animation-caption-font-family);
  font-size: var(--_omk-animation-caption-font-size);
  font-weight: var(--_omk-animation-caption-font-weight);
  line-height: var(--_omk-animation-caption-line-height);
  letter-spacing: var(--_omk-animation-caption-letter-spacing);
}

#animation-container {
  height: var(--_omk-animation-canvas-height);
  width: var(--_omk-animation-canvas-width);
  max-width: var(--_omk-animation-canvas-max-width);
}
